/**
 * Event arguments for the DataCommitted event.
*/
var IgrGridDataCommittedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridDataCommittedEventArgs() {
    }
    Object.defineProperty(IgrGridDataCommittedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridDataCommittedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridDataCommittedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridDataCommittedEventArgs.prototype, "commitID", {
        /**
         * Gets the ID for this commit.
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridDataCommittedEventArgs.prototype, "changes", {
        /**
         * Gets a list of the changes that were committed.
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridDataCommittedEventArgs;
}());
export { IgrGridDataCommittedEventArgs };
//# sourceMappingURL=igr-grid-data-committed-event-args.js.map
